import { defineMessages } from 'react-intl';

export default defineMessages({
    VehicleInfo: {
        id: 'cep.components.sgEndorsementSummaryInfo.VehicleInfo',
        defaultMessage: '{make} {model}, {registrationNumber}'
    },
    ChangesAdded: {
        id: 'cep.components.sgEndorsementSummaryInfo.ChangesAdded',
        defaultMessage: 'Changes made:'
    },
    ChangesRemoved: {
        id: 'cep.components.sgEndorsementSummaryInfo.ChangesRemoved',
        defaultMessage: 'Changes removed:'
    },
    AmountPaidLabel: {
        id: 'cep.components.sgEndorsementSummaryInfo.AmountPaidLabel',
        defaultMessage: 'Amount paid: {amount}'
    },
    NoFeeCharged: {
        id: 'cep.components.sgEndorsementSummaryInfo.NoFeeCharged',
        defaultMessage: 'No fee charged'
    },
    AmountRefundedLabel: {
        id: 'cep.components.sgEndorsementSummaryInfo.AmountRefundedLabel',
        defaultMessage: 'Amount refunded: {amount}'
    },
    NextInstallmentLabel: {
        id: 'cep.components.sgEndorsementSummaryInfo.NextInstallmentLabel',
        defaultMessage: 'Next installment: '
    },
    RemainingInstallmentsLabel: {
        id: 'cep.components.sgEndorsementSummaryInfo.RemainingInstallmentsLabel',
        defaultMessage: 'Remaining installments: '
    }
});
